// src/app/guards/auth.guard.ts (Create this file)
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../service/auth.service'; // Adjust path as needed
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const userId = route.queryParams['registeredUserId'];
    const authCode = route.queryParams['authCode'];
    
    // Scenario 1: User is redirected from SSO with authCode and userId
    if (userId && authCode) {
      console.log('AuthGuard: Found userId and authCode in query params. Attempting exchange.');
      this.authService.setUserId(userId);
      // Initiate the exchange and WAIT for it to complete
      return this.authService.exchangeAuthCodeForSession(userId, authCode).pipe(
        map(() => {
          console.log('AuthGuard: Session exchange successful. Navigating to /dealers and clearing query params.');
          // Redirect to the protected route AFTER successful auth.
          // navigateByUrl is better here to replace the current URL (with params) in history
          return this.router.createUrlTree(['/dealers']);
        }),
        catchError((error) => {
          console.error('AuthGuard: Session exchange failed during initial redirect.', error);
          this.authService.handleAuthFailure('Initial authentication failed.');
          return of(this.router.createUrlTree(['/auth-error'])); // Redirect to an error page
        })
      );
    }

    // Scenario 2: User tries to access a protected route directly (without initial auth params)
    // Check if session token already exists (e.g., from a previous successful login)
    if (this.authService.getIsLoggedIn()) {
      console.log('AuthGuard: Session token found. Allowing access to route.');
      return of(true); // Allow access
    }

    // Scenario 3: No auth params and no existing session token. Force login.
    console.log('AuthGuard: No auth params and no session token. Redirecting to login/error page.');
    // You might redirect to a dedicated login page (e.g., for direct logins or unauthenticated access)
    // or to the auth-error page if this is strictly an SSO flow.
    this.authService.handleAuthFailure('Session expired or not authenticated. Please log in.');
    return of(this.router.createUrlTree(['/auth-error'])); // Or ['/login']
  }
}